import React, { useContext } from 'react';
import { ContextServiceContent } from './Providers';
import { Carousel } from './Carousel';
import { Div } from './style';

export const App = () => {
  const content = useContext(ContextServiceContent);
  return <Div data-testid="App">{content ? <Carousel data={content} /> : null}</Div>;
};
export default App;
